export class ProduitPanier {
  constructor(produit, semaine, pression) {
    this.produit = produit;
    this.semaine = semaine;
    this.pression = pression;
  }

  equals(produitPanier) {
    return this.produit.code === produitPanier.produit.code
        && this.semaine.code === produitPanier.semaine.code
        && this.pression === produitPanier.pression;
  }

  tarif(formatSpot) {
    return this.produit.tarif(this.semaine, formatSpot, this.pression);
  }

  audience() {
    return this.produit.audience(this.semaine, this.pression);
  }

  pressionLibelle() {
    return this.produit.isPressionsMultiples() ? `${this.pression}` : '';
  }
}